/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Info_Load_TitleInputs */

const en_us2_exercise_personal_info_load_title = /** @type {(inputs: Exercise_Personal_Info_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heaviest weight`)
};

const pt_br2_exercise_personal_info_load_title = /** @type {(inputs: Exercise_Personal_Info_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior peso`)
};

const es_419_exercise_personal_info_load_title = /** @type {(inputs: Exercise_Personal_Info_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayor peso`)
};

const pt_pt2_exercise_personal_info_load_title = /** @type {(inputs: Exercise_Personal_Info_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior peso`)
};

const fr_fr2_exercise_personal_info_load_title = /** @type {(inputs: Exercise_Personal_Info_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge max`)
};

const de_de2_exercise_personal_info_load_title = /** @type {(inputs: Exercise_Personal_Info_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchstes Gewicht`)
};

const it_it2_exercise_personal_info_load_title = /** @type {(inputs: Exercise_Personal_Info_Load_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso più alto`)
};

/**
* | output |
* | --- |
* | "Heaviest weight" |
*
* @param {Exercise_Personal_Info_Load_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_info_load_title = /** @type {((inputs?: Exercise_Personal_Info_Load_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Info_Load_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_info_load_title(inputs)
	if (locale === "es-419") return es_419_exercise_personal_info_load_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_info_load_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_info_load_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_info_load_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_info_load_title(inputs)
	return en_us2_exercise_personal_info_load_title(inputs)
});
export { exercise_personal_info_load_title as "exercise-personal.info_load_title" }